
//the UI doc ordering is based on db's documentid and then optional or not, optional will be drag to bottom, Display_Order seems not work on this project
export const basicCoverageDetailId = 329

export const docIllnessMedicalMemoId = 643
export const docIllnessBillsId = 644
export const docIllnessDischargeSummaryId = 645
export const docIllnessAVSLicenseId = 687

export const docFuneralDeathCertId = 646
export const docFuneralReceiptId = 647
export const docFuneralAVSLicenseId = 688

export const docThirdPartInjBillsId = 648
export const docThirdPartInjMedicalReportId = 649
export const docThirdPartInjAVSLicenseId = 689
export const docThirdPartInjSummonsId = 720

export const docThirdPartLiaEstimateCostId = 652
export const docThirdPartLiaAVSLicenseId = 719
export const docThirdPartLiaIncidentReportId = 650
export const docThirdPartLiaPhotoDamageId = 651
export const docThirdPartLiaSummonsId = 721


export const docAccidentMedicalMemoId = 679
export const docAccidentBillsId = 680
export const docAccidentDischargeSummaryId = 681
export const docAccidentAVSLicenseId = 690

export const removeIllnessDocs = [643,644,645,687]
export const removeAccidentDoc = [679,680,681,688]
export const removeFuneralDocs = [646,647,689]
export const removeThirdpartDocs = [648,649,650,651,652,690]

export const medicalDocs = [643,649,679]

export const policyPattern = /^[Aa][a-zA-Z0-9,d]{7}$/

export const maritalStatusTableName = "MARITAL_STATUS"
export const relationshipTableName = "RELATIONSHIP"
export const lifeClaimantRelationship = "LIFE_CLAIMANT_RELATIONSHIP"
export const genderTableName = "COMMON_GENDER"
export const patientTypeTableName = "CLAIM_COMMON_PATIENT_TYPE"
export const wardStateTableName = "CLAIM_COMMON_WARD_STATE"
export const gigacoverDamageDescTableName = "CLAIM_GIGA_DAMAGE_DESC"

export const coverageDetailIdNonSurgicalIllness = 341
export const coverageDetailIdSurgicalIllness = 342
export const coverageDetailIdThirdPartyPropertyDamage = 343
export const coverageDetailIdThirdPartyBodilyInjury = 344
export const coverageDetailIdAccidentalInjury = 345
export const coverageDetailIdFuneralExpenses = 346

export const sep = "/"
